const serveAdd = () => import('@/views/main/serve/add/add.vue')
export default {
  path: '/main/serve/add',
  name: 'serveAdd',
  component: serveAdd,
  children: []
}
